import { useAnalytics } from '../context/AnalyticsContext';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
	if (!active || !payload?.length) return null;
	return (
		<div style={S.tooltip}>
			<div style={S.tooltipLabel}>{label}</div>
			<div style={{ color: '#7C3AED', fontSize: 12, marginTop: 3 }}>
				Views: <strong>{payload[0]?.value?.toLocaleString('en-GB')}</strong>
			</div>
		</div>
	);
};

export default function HourlyChart() {
	const { state } = useAnalytics();
	const { hourly, filteredHourly, dateHourly, dateHourlyLoading, filterType, selectedDate, loading, filterLoading } = state;

	// Priority: date drill-down > any active filter > global
	const hasDate    = !!selectedDate;
	const isFiltered = !!filterType;
	const source     = hasDate ? dateHourly : isFiltered ? filteredHourly : hourly;
	const busy       = hasDate ? dateHourlyLoading : isFiltered ? filterLoading : loading;

	if (busy) return <div style={S.empty}>Loading…</div>;

	const data = Array.from({ length: 24 }, (_, h) => ({
		hour:  `${String(h).padStart(2, '0')}h`,
		Views: source?.find(x => x.hour === h)?.views ?? 0,
	}));

	const max = Math.max(...data.map(d => d.Views), 1);

	return (
		<ResponsiveContainer width="100%" height={190}>
			<BarChart data={data} margin={{ top: 4, right: 8, left: -10, bottom: 0 }}>
				<CartesianGrid strokeDasharray="3 3" stroke="#F1F5F9" vertical={false} />
				<XAxis dataKey="hour" tick={{ fontSize: 9, fill: '#94A3B8', fontFamily: 'Outfit, sans-serif' }} interval={2} axisLine={false} tickLine={false} />
				<YAxis tick={{ fontSize: 10, fill: '#94A3B8', fontFamily: 'Outfit, sans-serif' }} axisLine={false} tickLine={false} />
				<Tooltip content={<CustomTooltip />} cursor={{ fill: '#F8FAFC' }} />
				<Bar dataKey="Views" radius={[3, 3, 0, 0]} maxBarSize={24}>
					{data.map((d, i) => {
						const intensity = d.Views === 0 ? 0.06 : 0.2 + (d.Views / max) * 0.8;
						const colour    = hasDate ? `rgba(29,78,216,${intensity})` : `rgba(124,58,237,${intensity})`;
						return <Cell key={i} fill={colour} />;
					})}
				</Bar>
			</BarChart>
		</ResponsiveContainer>
	);
}

const S = {
	empty:        { color: '#94A3B8', textAlign: 'center', padding: '40px 0', fontSize: 13 },
	tooltip:      { background: '#fff', border: '1px solid #E4E9F0', borderRadius: 10, padding: '10px 14px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' },
	tooltipLabel: { color: '#64748B', fontSize: 11, fontWeight: 600, marginBottom: 2 },
};